import { lazy } from 'react';
import {
    CREATE_PERMISSION,
    READ_PERMISSION,
    UPDATE_PERMISSION,
    USER_AUTH,
} from 'src/constants/permissions';
import { PermissionsGuard } from './components';

export const Routes = [
    {
        exact: true,
        path: '/create/users',
        guard: PermissionsGuard,
        roles: {
            permission: USER_AUTH,
            crud: CREATE_PERMISSION,
        },
        component: lazy(() => import('src/views/user/UserCreateView')),
    },
    {
        exact: true,
        path: '/management/users/:id',
        guard: PermissionsGuard,
        roles: {
            permission: USER_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/user/UserDetailsView')),
    },
    {
        exact: true,
        path: '/management/users/:id/edit',
        guard: PermissionsGuard,
        roles: {
            permission: USER_AUTH,
            crud: UPDATE_PERMISSION,
        },
        component: lazy(() => import('src/views/user/UserEditView')),
    },
    {
        exact: true,
        path: '/management/users',
        guard: PermissionsGuard,
        roles: {
            permission: USER_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/user/UserListView')),
    },
];
